export default __webpack_public_path__ + "images/346e40a092301c51febecc4c32684093-running_small.webp";